import { NgModule } from '@angular/core';
import { PrFeatureShellModule } from '@pr/feature-shell';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [PrFeatureShellModule.forRoot()],
  bootstrap: [AppComponent],
})
export class AppModule {}
